import Backbone from 'backbone';
import Ladda from 'ladda';
// import Syphon from 'backbone.syphon';
import _ from 'lodash';

import showErrorMessage from '@/util/showErrorMessage';
import showSuccessMessage from '@/util/ShowSuccessMessage';
import OrderTypes from '@/enums/OrderTypes';
import FileUploadModel from '@/fileupload/FileUploadModel';
import { getUserDetails } from '@/util/RoleUtils';
import showModal from '@/util/showModal';
import ConfirmationModalView from '@/views/ConfirmationModalView';
import { validateForm } from '@/util/ParsleyUtils';

import SaveDeliverySchedules from '../../../common/services/SaveDeliverySchedules';
import WideFormatDeliveryView from '../../forms/DeliveryFormView/WideFormatDeliveryView/WideFormatDeliveryView';
import Vb0DeliveryView from '../../forms/DeliveryFormView/VB0DeliveryView/VB0DeliveryView';
import DesktopDeliveryView from '../../forms/DeliveryFormView/DesktopDeliveryView/DesktopDeliveryView';
import PRTNRDeliveryView from '../../forms/DeliveryFormView/PRTNRDeliveryView/PRTNRDeliveryView';
import PRTNRA3DeliveryView from '../../forms/DeliveryFormView/PRNTRA3DeliveryView/PRNTRA3DeliveryView';
import MaintenanceDeliveryView from '../../forms/DeliveryFormView/MaintenanceDeliveryView/MaintenanceDeliveryView';
import MFDDeliveryView from '../../forms/DeliveryFormView/MFDDeliveryView/MFDDeliveryView';
import SpecialtyRequirementDeliveryView from '../../forms/DeliveryFormView/SpecialtyRequirementDeliveryView/SpecialtyRequirementDeliveryView';
import RelocationDeliveryView from '../../forms/DeliveryFormView/RelocationDeliveryView/RelocationDeliveryView';
import SaveMFDRelocationDeliverySchedule from '../../services/SaveMFDRelocationDeliverySchedules';
import ProcessDeliverySchedule from '../../services/ProcessDeliverySchedule';
import DeliveryScheduleUploadTmpl from '../../../common/fileupload/DeliveryScheduleUploadTmpl.hbs';
import DeliveryScheduleImportGridView from '../DeliveryScheduleImportGridView/DeliveryScheduleImportGridView';
import SubmittableOrderView from '../SubmittableOrderView/SubmittableOrderView';

import tmplOrderDeliveryView from './OrderDeliveryView.hbs';

const uuid = require('uuid');

const OrderDeliveryView = SubmittableOrderView.extend({
  template: tmplOrderDeliveryView,

  className: 'order-delivery-view',

  ui: {
    deliverySection: '.delivery-section',
    deliveryScheduleImportGrid: '.delivery-schedule-import-grid',
    btnDownloadCSV: '.btn-download-csv',
    btnDownloadTemplate: '.btn-download-template',
    btnUplaodDeliverySchedule: '.btn-uplaod-delivery-schedule',
    fileUploadInput: '#file-upload-input'
  },

  events: {
    'click @ui.btnDownloadCSV': 'onClickDownloadCSV',
    'click @ui.btnDownloadTemplate': 'onClickDownloadCSV',
    'click @ui.btnUplaodDeliverySchedule': 'onClickUploadDS',
    'change #file-upload-input': 'onFileSelect'
  },

  regions: {
    deliverySection: '@ui.deliverySection',
    deliveryScheduleImportGrid: '@ui.deliveryScheduleImportGrid'
  },

  childViewEvents: {
    'has:errors': 'onHasErrors',
    'no:errors': 'onNoErrors'
  },

  showSaveError() {
    showErrorMessage({
      errorCode: 'saveError',
      errorTitle: 'Save Error',
      errorMessage:
        'An error occurred while saving this order. Try again or contact an administrator if your issue persists.'
    });
  },

  showSaveSuccess() {
    showSuccessMessage({
      code: 'saveSuccess',
      title: 'Save Success',
      message: 'This order has been saved successfully.',
      hideAfter: 5
    });
  },

  templateContext() {
    const orderId = this.model.get('orderDetails').orderTypeId;
    if (orderId === OrderTypes.RELOCATION) {
      return { isRelocation: true };
    }
  },

  async initialize() {
    switch (this.model.get('orderDetails').orderTypeId) {
      case '1':
      case '3':
        this.showChildView(
          'deliverySection',
          new MFDDeliveryView({
            model: this.model
          })
        );
        break;

      case '2':
      case '14':
      case '15':
      case '22':
      case '23':
      case '24':
      case '25':
      case '26':
        this.showChildView(
          'deliverySection',
          new PRTNRDeliveryView({
            model: this.model
          })
        );
        break;
      case '13':
        this.showChildView(
          'deliverySection',
          new PRTNRA3DeliveryView({
            model: this.model
          })
        );
        break;
      case '4':
        this.showChildView(
          'deliverySection',
          new MaintenanceDeliveryView({
            model: this.model
          })
        );
        break;

      case '5':
        this.showChildView(
          'deliverySection',
          new WideFormatDeliveryView({
            model: this.model
          })
        );
        break;

      case '6':
      case '10':
      case '11':
        this.showChildView(
          'deliverySection',
          new DesktopDeliveryView({
            model: this.model
          })
        );
        break;

      case '12':
        this.model.set('showCSV', false);
        this.showChildView(
          'deliverySection',
          new RelocationDeliveryView({
            model: this.model
          })
        );
        break;

      case '16':
        this.showChildView(
          'deliverySection',
          new Vb0DeliveryView({
            model: this.model
          })
        );
        break;

      case '17':
        this.showChildView(
          'deliverySection',
          new WideFormatDeliveryView({
            model: this.model
          })
        );
        break;

      case '18':
        this.showChildView(
          'deliverySection',
          new Vb0DeliveryView({
            model: this.model
          })
        );
        break;

      case '19':
        this.showChildView(
          'deliverySection',
          new SpecialtyRequirementDeliveryView({
            model: this.model
          })
        );
        break;

      default:
        this.showChildView(
          'deliverySection',
          new DesktopDeliveryView({
            model: this.model
          })
        );
    }

    this.showChildView(
      'deliveryScheduleImportGrid',
      new DeliveryScheduleImportGridView({
        files: this.model.get('files')
      })
    );
  },

  async validate() {
    if (_.isFunction(this.getChildView('deliverySection').validate)) {
      const isValid = await this.getChildView('deliverySection').validate();
      if (!isValid) this.showSubmissionError(this.model.get('orderDetails')?.orderId);
      return isValid !== false;
    }
    return true;
  },

  onHasErrors() {
    this.trigger('has:errors');
  },

  onNoErrors() {
    this.trigger('no:errors');
  },

  async onSave() {
    if (this.model.get('orderDetails').orderTypeId === OrderTypes.RELOCATION) {
      await this.saveRelocationSchedules();
    } else {
      await this.saveDeliverySchedules();
    }
  },

  async saveRelocationSchedules() {
    const coll = this?.getChildView('deliverySection')?.getDeliveryData();
    const formData = {
      fromColl: coll[0].toJSON()[0],
      toColl: coll[1].toJSON()[0],
      orderId: this.model.get('orderDetails').orderId
    };
    try {
      await SaveMFDRelocationDeliverySchedule(formData);
      this.showSaveSuccess();
    } catch (err) {
      if (err) {
        this.showSaveError();
      }
    }
  },

  async saveDeliverySchedules() {
    const coll = this?.getChildView('deliverySection')?.getDeliveryData();
    if (!coll) {
      return;
    }

    _.each(coll, (item) => {
      const names = item.deliveryPOCName?.split(' ');
      if (names) {
        item.deliveryPOCFirstName = names[0];
        if (names.length > 1) {
          item.deliveryPOCLastName = names[1];
        }
      }
      if (item.regions) {
        item.regions = '';
      }
    });

    try {
      await SaveDeliverySchedules(this.model.get('orderDetails').orderId, 'ORDER', coll);
      this.showSaveSuccess();
    } catch (err) {
      if (err) {
        this.showSaveError();
      }
      throw new Error(err);
    }
  },

  async onClickDownloadCSV(e) {
    e.preventDefault();
    let isTemplate, button;

    if (e.target.innerText === 'Download Template') {
      isTemplate = true;
      button = this.ui.btnDownloadTemplate[0];
    } else {
      isTemplate = false;
      button = this.ui.btnDownloadCSV[0];
    }

    const spinner = Ladda.create(button);
    spinner.start();

    await this.getChildView('deliverySection').getDeliveryGridCSV(isTemplate);

    spinner.stop();
  },

  onClickUploadDS(e) {
    e.preventDefault();
    const self = this;
    const message = `Uploading a delivery schedule will delete the existing devices' data. Are you sure you want to proceed?`;

    showModal({
      title: 'Upload Delivery Schedule',
      view: new ConfirmationModalView({
        confirmButtonClass: 'btn-primary',
        rejectButtonClass: 'btn-secondary',
        confirmText: 'Yes',
        model: new Backbone.Model({
          message,
          onConfirm() {
            self.$('#file-upload-input').trigger('click');
            return Promise.resolve();
          }
        })
      })
    });
  },

  async onFileSelect(e) {
    e.preventDefault();
    const orderId = this.model.get('orderDetails').orderId;
    const orderTypeId = this.model.get('orderDetails').orderTypeId;
    const commandId = this.model.get('orderDetails').orderDetails.commandId;

    const files = e.target.files || e.originalEvent.dataTransfer.files;
    const file = files[0];
    const spinner = Ladda.create(this.ui.btnUplaodDeliverySchedule[0]);
    try {
      spinner.start();
      await validateForm(this.ui.fileUploadInput);
      const allowedExtension = '.csv';
      const fileName = file.name;
      const fileExtension = fileName.slice(fileName.lastIndexOf('.')).toLowerCase();

      if (fileExtension === allowedExtension) {
        const fileUploadModel = await this.uploadFile(file);
        spinner.stop();
        this.showUploadSuccess();
        const fileId = fileUploadModel.get('attachmentId');
        const fileName = fileUploadModel.attributes.metadata.fileName;
        ProcessDeliverySchedule({ orderId, orderTypeId, fileId, commandId, fileName });
        this.showDSPocessInitatedMessage();
      } else {
        spinner.stop();
        this.showFileTypeError(fileExtension);
      }
    } catch (err) {
      spinner.stop();
      this.showUploadError();
    }
  },

  async uploadFile(file) {
    const fileName = this.addUniqueStringBeforeExtension(file.name, uuid.v4());
    const uploadedBy = `${getUserDetails().firstName} ${getUserDetails().lastName}`;
    const csFolderId = this.model.get('orderDetails').orderDetails.csFolderId;
    const fileUploadModel = new FileUploadModel({
      metadata: {
        csFolderId,
        fileName,
        orderId: this.model.get('orderDetails').orderDetails.orderId,
        commandId: this.model.get('orderDetails').orderDetails.commandId,
        uploadedBy
      },
      file1: file,
      pathToFileId: 'html.head.script.Envelope.Body.UploadDeliveryScheduleResponse.FileID.__text',
      tmplMethodXML: DeliveryScheduleUploadTmpl
    });

    await fileUploadModel.upload();
    return fileUploadModel;
  },

  //allows upload of files with duplicate names
  addUniqueStringBeforeExtension(filename, stringToAdd) {
    const dotIndex = filename.lastIndexOf('.');
    if (dotIndex === -1) {
      return filename + stringToAdd;
    } else {
      return `${filename.substring(0, dotIndex)} ${stringToAdd}${filename.substring(dotIndex)}`;
    }
  },

  showUploadError() {
    showErrorMessage({
      errorCode: 'fileUploadError',
      errorTitle: 'File Upload Error',
      errorMessage: 'Error Uploading File.',
      hideAfter: 20
    });
  },

  showFileTypeError(fileExtension) {
    showErrorMessage({
      errorCode: 'fileTypeError',
      errorTitle: 'File Type Not Accepted',
      errorMessage: `The file that was selected is a ${fileExtension}. Please select a .csv file.`,
      hideAfter: 20
    });
  },

  showUploadSuccess() {
    showSuccessMessage({
      code: 'fileUploadSuccess',
      title: 'File Upload Successfully',
      message: 'This file has been successfully uploaded.',
      hideAfter: 5
    });
  },

  showDSPocessInitatedMessage() {
    showSuccessMessage({
      code: 'dsImportInitiated',
      title: 'Delivery Schedule Import Initiated',
      message:
        'Your delivery schedule is being processed. To see the most up-to-date information, please refresh the page after a few minutes.',
      hideAfter: 20
    });
  }
});

export default OrderDeliveryView;
